export const status = {
  job: {
    draft: "مسودة",
    planned: "مخطّط",
    released: "مُطلق",
    in_progress: "قيد التنفيذ",
    on_hold: "قيد الانتظار",
    ready_for_delivery: "جاهز للتسليم",
    completed: "مكتمل",
    cancelled: "ملغي",
  },
  operation: {
    not_ready: "غير جاهز",
    ready: "جاهز",
    active: "نشط",
    paused: "متوقف مؤقتاً",
    blocked: "معطّل",
    completed: "مكتمل",
  },
  task: {
    open: "مفتوح",
    overdue: "متأخر",
    completed: "مكتمل",
  },
  customer: {
    lead: "عميل محتمل",
    active: "نشط",
    archived: "مؤرشف",
  },
  priority: {
    low: "منخفضة",
    medium: "متوسطة",
    high: "عالية",
  },
  activity: {
    call: "مكالمة",
    meeting: "اجتماع",
    note: "ملاحظة",
    email: "بريد إلكتروني",
    site_visit: "زيارة موقع",
    other: "أخرى",
  },
  address: {
    billing: "فوترة",
    shipping: "شحن",
    site: "موقع",
    other: "أخرى",
  },
  quote: {
    draft: "مسودة",
    sent: "مُرسل",
    accepted: "مقبول",
    declined: "مرفوض",
    expired: "منتهي الصلاحية",
  },
  rfq: {
    open: "مفتوح",
    quoted: "تم التسعير",
    closed: "مغلق",
  },
  salesOrder: {
    open: "مفتوح",
    delivered: "تم التسليم",
    cancelled: "ملغي",
  },
  product: {
    equipment: "معدات",
    fabricated: "قطعة مصنّعة",
    component: "مكوّن",
    service: "خدمة",
  },
  estimate: {
    material: "مواد",
    labor: "عمالة",
    work_center: "وقت مركز العمل",
    outsourced: "عملية خارجية",
    fixed: "ثابت / أخرى",
  },
  production: {
    good: "سليم",
    scrap: "هالك",
    rework: "إعادة تصنيع",
  },
  reason: {
    scrap: "هالك",
    rework: "إعادة تصنيع",
  },
  purchaseOrder: {
    draft: "مسودة",
    issued: "صادر",
    partially_received: "مستلم جزئياً",
    received: "مستلم",
    cancelled: "ملغي",
  },
  invoice: {
    draft: "مسودة",
    issued: "صادرة",
    partially_paid: "مدفوعة جزئياً",
    paid: "مدفوعة",
    overdue: "متأخرة",
    void: "ملغاة",
  },
  direction: {
    in: "داخل",
    out: "خارج",
  },
  severity: {
    low: "منخفضة",
    medium: "متوسطة",
    high: "عالية",
  },
};
